"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fontanellato": {
    "20b410ae": [{
      "hkey": "af362feb",
      "slug": "fontanellato",
      "name": "Fontanellato",
      "primary": true,
      "skipSearch": false
    }],
    "albareto": [{
      "hkey": "af362feb",
      "slug": "fontanellato",
      "name": "Fontanellato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9fb11980": [{
      "hkey": "6bfcb4eb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ghiara": [{
      "hkey": "6bfcb4eb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fontanellato"
    }],
    "d26619f6": [{
      "hkey": "af362feb",
      "slug": "fontanellato",
      "name": "Fontanellato",
      "primary": true,
      "skipSearch": false
    }],
    "grugno": [{
      "hkey": "af362feb",
      "slug": "fontanellato",
      "name": "Fontanellato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;